<div id="company-convenios-tab" class="company-convenios-tab">
    <h2>Convenios
        <button class="adder" type="button" (click)="copiarConvenios()" mat-button>Copiar a niveles inferiores</button>
        <button class="adder" type="button" mat-button [matMenuTriggerFor]="atributosMenu">Cargar atributos</button>
        <button class="add-new" type="button" mat-button (click)="createConvenios()">+</button>
        <mat-menu #atributosMenu="matMenu" [overlapTrigger]="false">
            <a>
                <button (click)="cargerEvent(notnullatributo.attributoValue)" *ngFor="let notnullatributo of dataSourceNotNullAttributo" mat-menu-item>
                    <span>{{ notnullatributo.attributoName }}</span>
                </button>
            </a>
            
        </mat-menu>
    </h2>
    
    <div class="table-view">
        
        <div class="">
            <div *ngIf="isLoading" class="m-auto">
                <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                </mat-progress-spinner>
            </div>
            <table *ngIf="!isLoading" aria-describedby="" des mat-table [dataSource]="dataSource">

                <!-- Position Column -->
                <ng-container matColumnDef="position">
                    <th id mat-header-cell *matHeaderCellDef> Tipo </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field appearance="fill">
                            <mat-select id="atributo_{{element.id}}" [(ngModel)]="element.tipoAtributo" [disabled]="true">
                                <mat-option *ngFor="let attributo of dataSourceAllAttributo" [value]="attributo.attributoValue" >{{ attributo.attributoName }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <th id="" mat-header-cell *matHeaderCellDef> Atributo </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" value="{{element.atributo}}" matInput placeholder="" [disabled]="true">
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Weight Column -->
                <ng-container matColumnDef="weight">
                    <th id="" mat-header-cell *matHeaderCellDef> Convenio </th>
                    <td mat-cell *matCellDef="let element">                   
                        <mat-form-field appearance="fill">
                            <mat-select id="convenio_{{element.id}}" [(ngModel)]="element.convenioId" [disabled]="true" >
                                <mat-option *ngFor="let convenio of dataSourceConvenio"  [value]="convenio.convenioId" >{{ convenio.nombre }}</mat-option>
                              </mat-select>
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Symbol Column -->
                <ng-container matColumnDef="symbol">
                    <th id="" mat-header-cell *matHeaderCellDef> Salario bruto </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" class="curr" value="{{element.salarioBruto |number:'1.2-2'}}"  matInput placeholder="" [disabled]="true">
                            <!-- <input type="text" class="curr" value="{{element.salarioBruto | currency:'EUR':true}}"  matInput placeholder="" [disabled]="true"> -->
                            <span matSuffix>€</span>
                        </mat-form-field>
                    </td>
                </ng-container>

                <!-- Extra Column -->
                <ng-container matColumnDef="extra">
                    <th id="" mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deleteConvenios(element)"><mat-icon>delete_forever</mat-icon></button>
                        <button mat-button (click)="editConvenios(element)"><mat-icon>edit</mat-icon></button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
    </div>
</div>